export default __webpack_public_path__ + "static/media/fork-me.7ba8370e.png";